import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		backgroundColor: token('elevation.surface.sunken'),
	},
	fill: {
		flex: '1',
		minWidth: '0px',
	},
	skeletonRow: {
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
	},
	skeleonRowBorder: {
		borderBottom: `${token('border.width')} solid ${token('color.border.disabled')}`,
	},
	skeletonRows: {
		backgroundColor: token('elevation.surface.raised'),
		borderRadius: token('radius.large'),
	},
});

interface LoadingSkeletonProps {
	testId?: string;
}

function SkeletonRow() {
	return (
		<Inline
			space="space.150"
			alignBlock="center"
			xcss={cx(styles.skeletonRow, styles.skeleonRowBorder)}
		>
			<Skeleton width="32px" height="32px" borderRadius={token('radius.large')} />
			<Stack space="space.100" xcss={styles.fill}>
				<Skeleton width="40%" height="12px" borderRadius={token('radius.small')} />
				<Skeleton width="70%" height="12px" borderRadius={token('radius.small')} />
			</Stack>
		</Inline>
	);
}

export function LoadingSkeleton({
	testId = 'user-profile-preview-skeleton',
}: LoadingSkeletonProps): React.JSX.Element {
	return (
		<Stack space="space.150" testId={testId} xcss={styles.root}>
			<Inline space="space.200" alignBlock="center">
				<Skeleton width="48px" height="48px" borderRadius={token('radius.large')} />
				<Stack space="space.100" xcss={styles.fill}>
					<Skeleton width="35%" height="12px" borderRadius={token('radius.small')} />
					<Skeleton width="65%" height="12px" borderRadius={token('radius.small')} />
				</Stack>
			</Inline>
			<Stack xcss={styles.skeletonRows}>
				<SkeletonRow />
				<SkeletonRow />
				<SkeletonRow />
				<SkeletonRow />
				<Box xcss={styles.skeletonRow} />
			</Stack>
		</Stack>
	);
}
